import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import Typography from '@material-ui/core/Typography';
import CarLogo from './CarLogo';
import {API} from 'aws-amplify';
import Deals from './dashboard/Deals';
import ReactGA from 'react-ga';


const styles = theme => ({
  button: {
    //margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  detailHeader: {
    //backgroundColor: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '8px',
    position: 'relative',
    //paddingLeft: '5px',
    //paddingTop: '5px',
  },
  contrastText: {
    //color: theme.palette.primary.contrastText,
  },
});

class DealsByMake extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deals: [],
      id: props.match.params.id
    };
  }

  componentWillMount() {
    const { leasyZip } = this.props;
    const { id } = this.state;

    if (leasyZip) {
      this.fetchDealsByMake(id, leasyZip);
    }

    ReactGA.initialize('UA-107081605-2');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // console.log('in componentDidUpdate');
    // console.log('leasyZip: ' + this.props.leasyZip);

    const { leasyZip } = this.props;
    const { id } = this.state;

    if (leasyZip !== prevProps.leasyZip) {
       this.fetchDealsByMake(id, leasyZip);
    }
  }

  //get all deals by car make
  fetchDealsByMake = async (id, zip) => {
    let requestParams = {
        headers: {'content-type': 'application/json'},
        body : {
            'id': id,
            'zip': zip
        }
    }

    API.post('leasy','/get-deals-by-make', requestParams)
        .then(data => {
          //console.log(data);
          this.setState({
              deals: data
          });
          return data;
        })
        .catch (err => console.log(err))
  }

  handleBackClick = () => {
    //console.log('back clicked');
    this.props.history.goBack()
  }

  render() {
    const { classes } = this.props;
    const { deals, id } = this.state;

    return (
      <div>
        <Grid container alignItems="stretch" justify="center" spacing={4}>
          <Grid item xs={12} md={8}>
            <div className={classes.detailHeader}>
              <IconButton className={classes.contrastText} aria-label="Menu" onClick={this.handleBackClick}>
                <NavigateBeforeIcon />
              </IconButton>
              <CarLogo brand={id}/>
              <Typography className={classes.contrastText}  variant="subheading" color="inherit">
                ALL DEALS
              </Typography>
            </div>
            { deals && <Deals list={deals}/> }
          </Grid>
          <Grid item xs={false} md={4}>
            <a class="twitter-timeline" data-width="450" data-height="1200" data-theme="light" href="https://twitter.com/BMW?ref_src=twsrc%5Etfw">BMW Updates</a>
          </Grid>
        </Grid>
      </div>
    );
  }

}

DealsByMake.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DealsByMake);



// WEBPACK FOOTER //
// ./src/components/DealsByMake.jsx